import React from 'react';
import HeaderFooterLayout from 'layouts/HeaderFooterLayoutNew';
import StatementsHeader from './StatementsHeader';
import styles from './styles.module.css';
import CheckHistoryNew from '../CheckHistoryNew';

const TransactionNew = ({
  loadStatement,
  isDownload,
  user,
  visits,
  loadHistory,
  checkHistory,
  amount,
  idCA,
  resetHistory,
  loadHistoryPDF,
  isRequestingPDF,
  isRequesting,
}) => {
  const statementProps = {
    loadStatement,
    isDownload,
    user,
  };

  const checkInProps = {
    visits,
    loadHistory,
    checkHistory,
    amount,
    idCA,
    resetHistory,
    loadHistoryPDF,
    isRequestingPDF,
    isRequesting,
  };
  return (
    <HeaderFooterLayout>
      <div className={styles.containerMain}>
        <StatementsHeader statementProps={statementProps} />
        <CheckHistoryNew checkInProps={checkInProps}/>
      </div>
    </HeaderFooterLayout>
  );
};

export default TransactionNew;
